/**
 * @Description 客流计数 - 任务详情抽屉
 */
import { FC, useEffect, useState } from 'react';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import { useMethods } from '@lhb/hook';
import Top from './Top';
import Main from './Main';
import { taskSpotDetail, taskSpotDetailDemo } from '@/common/api/passengerflowcount';


const SpotDetailDrawer: FC<{
  data: any;
  setData: any;
  isDemonstrate?: boolean;
  ableToChangepoint?: boolean; // 是否展示机会点操作
}> = ({ data, setData, isDemonstrate, ableToChangepoint = true }) => {

  const [spotDetail, setSpotDetail] = useState<any>({}); // 点位详情

  useEffect(() => {
    // if (data.visible && data.data?.spotId) {
    if (data.visible && data.data?.id) { // 20240829换了接口，换成点位列表接口
      methods.getTaskSpotDetail();
    }
  }, [data.visible, data.data?.id]);

  const methods = useMethods({
    getTaskSpotDetail() {
      const api = isDemonstrate ? taskSpotDetailDemo : taskSpotDetail;
      // 0829换了接口，换成点位列表接口
      api(data.data?.id).then((res) => {
        setSpotDetail({ ...res.data || {} });
      });
    },
  });

  return (
    <V2Drawer open={data.visible} onClose={() => setData(false)}>
      {data.data?.id && (
        <>
          <Top detail={spotDetail} ableToChangepoint={ableToChangepoint}/>
          <Main spotDetail={spotDetail} isDemonstrate={isDemonstrate}/>
        </>
      ) }
    </V2Drawer>
  );
};
export default SpotDetailDrawer;
